module.exports = __webpack_public_path__ + "static/media/Quest20_Lock@3x.fea022e9.png";